<template>
  <div class="page-content" style="padding: 15px">
    <!-- {{ remoteStreams }} -->
    <div class="meeting-container">
      <el-button-group>
        <el-button type="primary" icon="el-icon-s-grid"></el-button>
        <el-button type="info" icon="el-icon-s-custom"></el-button>
      </el-button-group>
      <div v-if="style === 'focus'" class="row h-100 w-100">
        <div :class="participants.length > 1 ? 'col-10' : 'col-12'">
          <div>
            <!-- Main Video Section -->
            <div class="video-focus h-100 w-100">
              <video id="focusedVideo" ref="focusedVideo" autoplay playsinline></video>
              <div class="participant-label">
                <font-awesome v-if="focusedParticipant.audioMuted" icon="volume-mute"/>
                {{ focusedParticipant.profile_name }}
              </div>
            </div>
          </div>
        </div>
        <div class="overflow-auto" :class="participants.length > 1 ? 'col-2' : 'hidden'">
          <!-- Sidebar with Participant Thumbnails -->
          <div class="video-sidebar">
            <!-- <div class="video-thumbnail w-100" @click="setFocus('me')">
              <video ref="localVideo" autoplay playsinline></video>
              <div class="participant-label">
                <font-awesome v-if="!micOn" icon="volume-mute"/>
                You
              </div>
            </div> -->
            <div
              v-for="(participant, id) in participants" :key="id"
              class="video-thumbnail w-100"
              @click="setFocus(participant.id)"
            >
              <video :id="`participant-video-container-${participant.id}`" :ref="participant.videoRef" autoplay playsinline></video>
              <!-- <div class="avatar-container text-center">
                <el-avatar class="align-middle" :src="'https://api.dicebear.com/9.x/initials/svg?seed=' + remoteStreamIds[participant.id].profile_name"/>
              </div> -->
              <div class="participant-label">
                <font-awesome v-if="participant.audioMuted" icon="volume-mute"/>
                {{ participant.profile_name }}
                <!-- {{ remoteStreamIds[participant.id].profile_name }} -->
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-else-if="style === 'grid'" class="row h-100 w-100">
        <div class="overflow-auto" :class="thumbnailStyle">
          <!-- Sidebar with Participant Thumbnails -->
          <div class="video-sidebar">
            <div
              thumbnail
              v-for="(participant, id) in participants" :key="id"
              class="video-thumbnail-grid h-100 w-100"
              @click="setFocus(participant.id)"
            >
              <video :id="`participant-video-container-${participant.id}`" :ref="participant.videoRef" autoplay playsinline></video>
              <!-- <div class="avatar-container text-center">
                <el-avatar class="align-middle" :src="'https://api.dicebear.com/9.x/initials/svg?seed=' + remoteStreamIds[participant.id].profile_name"/>
              </div> -->
              <div class="participant-label">
                <font-awesome v-if="participant.audioMuted" icon="volume-mute"/>
                {{ participant.profile_name }}
                <!-- {{ remoteStreamIds[participant.id].profile_name }} -->
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="d-flex justify-content-center mt-3">
        <el-button circle size="small" type="info" @click="toggleMic">
          <FeatherIcon :type="micOn ? 'mic' : 'mic-off'" size="15px" class="m-1" />
        </el-button>
        <el-button v-if="room && this.focusedParticipant.id !== 'sharing'" circle size="small" type="warning" @click="startSharing">
          <FeatherIcon type="share" size="15px" class="m-1" />
        </el-button>
        <el-button v-else-if="room && this.focusedParticipant.id == 'sharing'" circle size="small" type="danger" @click="stopSharing">
          <FeatherIcon type="square" size="15px" class="m-1" />
        </el-button>
        <el-button size="small" type="info" @click="toggleCam" circle>
          <FeatherIcon :type="camOn ? 'video' : 'video-off'" size="15px" class="m-1" />
        </el-button>
        <el-button v-if="!room" class="p-2" size="small" @click="initJitsi" :loading="loading.join">
          Join Meeting
        </el-button>
        <el-button v-if="room" circle size="small" type="danger" @click="endCall">
          <FeatherIcon type="log-out" size="15px" class="m-1" />
        </el-button>
        <!-- <el-button v-if="room" size="small" circle type="danger" @click="endCall">
          <FeatherIcon type="log-out" size="15px" class="m-1" />
        </el-button> -->
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable no-undef */
export default {
  data() {
    return {
      focusedParticipant: {},
      participants: [],
      connection: null,
      room: null,
      localTrack: null,
      localAudioTrack: null,
      localVideoTrack: null,
      // remoteStreams: [{
      //   profile_name: 'Jasson',
      //   id: 'test',
      // }],
      style: 'focus', // grid, focus
      userProfile: {
        name: '',
        avatar: '',
        background: '',
        role: '',
      },
      remoteStreams: null,
      remoteStreamIds: {},
      // remoteStreamIds: {
      //   test: {
      //     profile_name: 'Jasson',
      //   },
      // },
      isMuted: false,
      roomName: 'testroom',
      isHost: false,
      micOn: true,
      camOn: true,
      token: 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJhdWQiOiJqaXRzaSIsImlzcyI6InlvdXItYXBwIiwic3ViIjoibWVldC55b3VyZG9tYWluLmNvbSIsInJvb20iOiJNeUN1c3RvbVJvb20iLCJleHAiOjE3NDAwNTI0MjQsImNvbnRleHQiOnsidXNlciI6eyJhdmF0YXIiOiJodHRwczovL3lvdXJkb21haW4uY29tL2F2YXRhci5wbmciLCJuYW1lIjoiSG9zdCBVc2VyIiwiZW1haWwiOiJob3N0QGV4YW1wbGUuY29tIiwibW9kZXJhdG9yIjp0cnVlfX0sImlhdCI6MTc0MDA0ODgyNH0.z9D658cso7pfrmEvuJp3pBplFFi2rgmRmkKPxaZnbWI',
      // participantVideos: {},
      loading: {
        join: false,
      },
    };
  },
  computed: {
    thumbnailStyle() {
      let style = 'col-lg-2 col-sm-2';
      if (this.participants.length <= 4) {
        style = 'col-lg-6 col-sm-6';
      } else if (this.participants.length <= 12) {
        style = 'col-lg-4 col-sm-4';
      } else if (this.participants.length <= 16) {
        style = 'col-lg-3 col-sm-3';
      }
      return style;
    },
  },
  methods: {
    createLocalTrack() {
      // Create local video/audio stream
      // { 1: localStream }
      JitsiMeetJS.createLocalTracks({
        devices: ['audio', 'video'],
        // resolution: 1080,
        // cameraDeviceId: '',
        // micDeviceId: '',
        // desktopSharingSourceDevice: '',
      }).then((localStream) => {
        this.localTrack = localStream;
        this.localVideoTrack = localStream.find((v) => v.type === 'video');
        this.localAudioTrack = localStream.find((v) => v.type === 'audio');
        if (!this.focusedParticipant.id) {
          this.$refs.focusedVideo.srcObject = new MediaStream([this.localVideoTrack.getTrack()]);
          this.focusedParticipant = {
            id: 'me',
            connectionJid: 'me',
            videoRef: 'participantVideo_me',
            audioMuted: false,
            videoMuted: false,
            profile_name: this.userProfile.name,
            role: 'moderator',
          };
        }
      });
    },
    async initJitsi() {
      const domain = 'meet.makna.ai';
      const options = {
        hosts: {
          domain,
          muc: `conference.${domain}`,
          anonymousdomain: `guest.${domain}`,
        },
        serviceUrl: `https://${domain}/http-bind`,
        clientNode: 'custom-client',
      };

      // Initialize connection
      this.connection = new JitsiMeetJS.JitsiConnection(null, this.token, options);
      console.log('this.token', this.token);
      console.log('connection', this.connection);

      this.connection.addEventListener(JitsiMeetJS.events.connection.CONNECTION_ESTABLISHED, this.onConnected);
      this.connection.addEventListener(JitsiMeetJS.events.connection.CONNECTION_FAILED, this.onFailed);
      this.connection.addEventListener(JitsiMeetJS.events.connection.CONNECTION_DISCONNECTED, this.onDisconnected); // disconnect
      this.loading.join = true;
      await this.connection.connect();
      this.participants.push({
        id: 'me',
        connectionJid: 'me',
        videoRef: 'participantVideo_me',
        audioMuted: false,
        videoMuted: false,
        profile_name: this.userProfile.name,
        role: 'moderator',
      });
      if (this.participants.length > 1) {
        this.style = 'grid';
      } else {
        this.style = 'focus';
      }
      // const videoElement = document.getElementById(`participant-video-container-${participantId}`);
      // this.localVideoTrack.attach(videoElement);
      this.$refs.participantVideo_me.srcObject = new MediaStream([this.localVideoTrack.getTrack()]);
      this.loading.join = false;
      this.remoteStreams = new MediaStream();
    },
    onFailed() {
      this.$message({
        type: 'error',
        message: 'Failed joined to the room. Connection failed',
      });
    },
    onDisconnected() {
      this.$message({
        type: 'error',
        message: 'Failed joined to the room. Disconnected',
      });
    },
    onConnected() {
      this.room = this.connection.initJitsiConference(this.roomName, {});
      this.room.on(JitsiMeetJS.events.conference.TRACK_ADDED, this.onRemoteTrack);
      this.room.on(JitsiMeetJS.events.conference.TRACK_REMOVED, this.onRemoveTrack);
      this.room.on(JitsiMeetJS.events.conference.USER_JOINED, this.onUserJoined);
      this.room.on(JitsiMeetJS.events.conference.TRACK_MUTE_CHANGED, this.onMuteTrack);
      this.room.on(JitsiMeetJS.events.conference.USER_LEFT, this.onUserLeft);
      this.room.join();
      // start save connected join - user join save
      this.$message({
        type: 'success',
        message: 'Joined to the room',
      });
      // end save
      this.room.addTrack(this.localAudioTrack);
      this.room.addTrack(this.localVideoTrack);
    },
    setFocus(id) {
      const get_participant = this.participants.find((v) => v.id === id);
      if (get_participant) {
        this.focusedParticipant = get_participant;
        console.log(this.remoteStreams);
        this.$refs.focusedVideo.srcObject = new MediaStream([this.remoteStreams.getTrack()]);
      }
    },
    onUserJoined(id, JitsiParticipant) {
      console.log('onUserJoined', id, JitsiParticipant);
      const obj = {
        id,
        connectionJid: JitsiParticipant._connectionJid,
        videoRef: `participantVideo_${id}`,
        audioMuted: false,
        videoMuted: false,
        profile_name: JitsiParticipant._displayName || 'Guest',
        role: JitsiParticipant._role,
      };
      this.participants.push(obj);
    },
    onRemoteTrack(track) {
      if (track.isLocal()) return;
      const participantId = track.getParticipantId();
      console.log('new remote stream', participantId, track);
      if (this.participants.length > 1 && this.style === 'focus') {
        this.style = 'grid';
      }
      if (track.type === 'video') {
        const videoElement = document.getElementById(`participant-video-container-${participantId}`);
        track.attach(videoElement);
        const obj = this.participants.find((v) => v.id === participantId);
        // this.participantVideos[participantId] = obj;
        this.$refs[`participantVideo_${participantId}`].srcObject = new MediaStream([track.getTrack()]);
        if (!this.focusedParticipant.id) {
          this.$refs.focusedVideo.srcObject = new MediaStream([track.getTrack()]);
          this.focusedParticipant = obj;
        }
        // this.remoteStreams.addTrack(track.getTrack());
      }
      if (track.type === 'audio') {
        console.log(track.getTrack());
        // console.log(track.stream);
        // console.log(track.streams);
        // console.log(track.streams[0]);
        // audio.srcObject = track.get;
        const audio = document.querySelector('audio#audio');
        const set_stream = new MediaStream([track.getTrack()]);
        audio.srcObject = set_stream;
        // this.remoteStreams.addTrack(track.getTrack());
        // set_stream.getTracks().forEach((tr) => {
        //   if (tr) {
        //     this.remoteStream.addTrack(tr); // Add each track to the remote stream
        //   }
        // });
      }
    },
    onUserLeft(id, JitsiParticipant) {
      console.log('onUserLeft', id, JitsiParticipant);
      const idx = this.participants.findIndex((v) => v.id === id);
      console.log('user left', idx);
      this.participants.splice(idx, 1);
      document.getElementById(`participant-video-container-${id}`).remove();
    },
    onRemoveTrack(track) {
      console.log('remove track', track);
      //   if (track.isLocal()) return;
      //   const participantId = track.getParticipantId();
      //   console.log('remove exist stream', participantId, track);

      //   console.log('stream after remove');
      //   console.log(this.remoteStreams.getTracks());
      //   this.$nextTick(() => {
      //     if (track.type === 'video') {
      //       document.getElementById(`participant-video-container-${participantId}`).remove();
      //     }
      //   });
    },
    endCall() {
      this.room.leave();
      this.connection.disconnect();
      this.remoteStreams = null;
      this.participants = [];
      this.room = null;
      this.focusedParticipant = {};
    },
    toggleMic() {
      this.micOn = !this.micOn;
      // this.localAudioTrack.getAudioTracks().forEach((track) => {
      //   track.enabled = !this.micOn;
      // });
      if (this.focusedParticipant.id === 'me') {
        this.focusedParticipant.audioMuted = !this.micOn;
      }
      console.log(this.localAudioTrack);
      if (!this.micOn) {
        this.localAudioTrack.mute();
      } else {
        this.localAudioTrack.unmute();
      }
      // if (!this.micOn) this.localAudioTrack.mute();
      // else {
      //   this.localAudioTrack.unmute();
      // }
    },
    toggleCam() {
      this.camOn = !this.camOn;
      if (!this.camOn) {
        this.localVideoTrack.mute();
      } else {
        this.localVideoTrack.unmute();
        this.$refs.participantVideo_me.srcObject = new MediaStream([this.localVideoTrack.getTrack()]);
        if (this.focusedParticipant.id === 'me') {
          this.$refs.focusedVideo.srcObject = new MediaStream([this.localVideoTrack.getTrack()]);
        }
      }
    },
    onMuteTrack(track) {
      if (track.isLocal()) {
        if (!track.muted) this.$refs.localVideo.srcObject = new MediaStream([track.getTrack()]);
        return;
      }
      const participantId = track.getParticipantId();
      console.log('Muted track', participantId, track);
      // if (this.remoteStreamIds[participantId][`${track.type}Muted`] !== undefined) {
      //   this.remoteStreamIds[participantId][`${track.type}Muted`] = track.muted;
      // }
    },
    async startSharing() {
      const stream = await navigator.mediaDevices.getDisplayMedia();
      const videoTrack = stream.getVideoTracks()[0];
      // const audioTrack = stream.getAudioTracks()[0];
      this.$refs.focusedVideo.srcObject = new MediaStream([videoTrack]);
      this.focusedParticipant = {
        id: 'sharing',
        connectionJid: 'sharing',
        videoRef: 'sharingVideo',
        audioMuted: false,
        videoMuted: false,
        profile_name: 'Screen Sharing',
        role: 'moderator',
      };
      await JitsiMeetJS.createLocalTracks({
        devices: ['video'],
        desktopSharingSourceDevice: stream.id,
        // constraints: {
        //   video: { mediaSource: 'screen' }
        // }
      }).then((screenTracks) => {
        const screenTrack = screenTracks[0];
        this.localTrack.push(screenTrack);
        this.room.addTrack(screenTrack);
      });
      // this.room.addTrack(audioTrack);
      // await sharing(list.id);
    },
    stopSharing() {
      const screenTrack = this.localTrack.find((track) => track.getType() === 'video' && track.mediaSource === 'screen');
      if (screenTrack) {
        // Stop the track and remove it from the conference
        screenTrack.stop();
        this.room.removeTrack(screenTrack);
        this.localTrack = this.localTrack.filter((track) => track !== screenTrack);
      }
    },
  },
  mounted() {
    JitsiMeetJS.init();
    this.$nextTick(() => {
      if (this.$store.state.auth && this.$store.state.auth.userProfile) {
        this.userProfile = this.$store.state.auth.userProfile;
      }
      this.createLocalTrack();
    });
  },
};
</script>

<style scoped>
.meeting-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  height: 100%;
  background: #222;
  padding: 15px 5px 15px 5px;
  border-radius: 5px;
}

.video-focus {
  flex-grow: 1;
  width: 100%;
  height: auto;
  max-height: 100%;
  background: black;
  border-radius: 10px;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
}
.video-focus video {
  /* width: 100%;
  height: 100%; */
  width: 100%;
  border-radius: 5px;
  /* height: auto; */
  object-fit: cover;
  height: 500px;
}

.video-sidebar {
  /* position: absolute; */
  /* right: 10px; */
  /* top: 10px; */
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.video-thumbnail {
  /* width: 120px; */
  /* height: 100%; */
  background: black;
  border-radius: 5px;
  position: relative;
  cursor: pointer;
}
.video-thumbnail video {
  width: 100%;
  border-radius: 5px;
  height: 100px;
  object-fit: cover;
  max-height: 100px;
}

.video-thumbnail-grid {
  /* width: 120px; */
  /* height: 100%; */
  background: black;
  border-radius: 5px;
  position: relative;
  cursor: pointer;
}
.video-thumbnail-grid video {
  width: 100%;
  border-radius: 5px;
  height: 100%;
  object-fit: cover;
  max-height: 300px;
}

.participant-label {
  position: absolute;
  bottom: 5px;
  background: rgba(0, 0, 0, 0.5);
  color: white;
  padding: 3px 8px;
  border-radius: 5px;
  font-size: 12px;
}

.controls {
  display: flex;
  gap: 10px;
  margin-top: 10px;
}

.avatar-container {
  /* display: flex;
  align-items: center;
  justify-content: center;
  height: 100%; */
  /* margin-top: 50%; */
  text-align: center;
}
</style>
